export default __webpack_public_path__ + "static/media/ib6.e8e47f3e.png";